import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { reduxForm, Field } from 'redux-form'
import { localize } from 'helpers/translator'

import MultiSelectDropdownForm from 'components/multi_select_dropdown/multi_select_dropdown_form'
import { MainButton, CancelButton } from 'components/button'
import SubjectsGradesSubtitle from '../subtitle/subjects_grades_subtitle'

import styles from './subjects_grades_teacher_form.scss'

const validate = () => {
	const errors = {}
	return errors
}

class SubjectsGradesTeacherForm extends Component {

	constructor() {
		super()
		this.formCancelHandler = this.formCancelHandler.bind(this, 'subjectsGradesTeacherForm')
		this.formSubmitHandler = this.formSubmitHandler.bind(this)
	}

	formCancelHandler() {
		this.props.cancel()
	}

	formSubmitHandler(values) {
		return new Promise((resolve, reject) => {
			this.props.saveTeacherInfo(values, resolve, reject)
		})
	}

	render() {
		const isDisabled = this.props.status > 1
		return (
			<div styleName='wrapper'>
				<SubjectsGradesSubtitle text={localize('my_account_profile_teacher_form_subtitle')}></SubjectsGradesSubtitle>
				<form id='subjectsGradesTeacherForm' onSubmit={this.props.handleSubmit(this.formSubmitHandler)}>
					<div styleName='field'>
						<label styleName='field-label'>{localize('my_account_profile_teacher_form_grades_label')}</label>
						<Field
							name={'gradeIds'}
							component={MultiSelectDropdownForm}
							props={{
								tabIndex: 16,
								large: true,
								placeholder: localize('my_account_profile_teacher_form_grades_placeholder'),
								options: this.props.grades,
							}}
						/>
					</div>
					<div styleName='field'>
						<label styleName='field-label'>{localize('my_account_profile_teacher_form_subjects_label')}</label>
						<Field
							name={'subjectIds'}
							component={MultiSelectDropdownForm}
							props={{
								tabIndex: 17,
								large: true,
								placeholder: localize('my_account_profile_teacher_form_subjects_placeholder'),
								options: this.props.subjects,
							}}
						/>
					</div>
					<div styleName='btn-bar'>
						<div styleName='btn-bar-button'>
							<CancelButton tabIndex={18} focus={true} onClick={this.formCancelHandler}>{localize('global_cancel')}</CancelButton>
						</div>
						<div styleName='btn-bar-button'>
							<MainButton tabIndex={19} focus={true} disabled={isDisabled} type='submit'>{localize('global_saveChanges')}</MainButton>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

const DecoratedSubjectsGradesTeacherForm = reduxForm({
	form: 'subjectsGradesTeacherForm',
	fields: ['gradeIds', 'subjectIds'],
	validate,
})(CSSModules(SubjectsGradesTeacherForm, styles, {allowMultiple: true}))

export default (DecoratedSubjectsGradesTeacherForm)
